import React from 'react';

import { Container, Text, TextHighlight } from './styles';

function BannerSection() {
  return (
    <Container>
      <Text>
        Fique atento aos principais critérios elegíveis para negociação da
        Precatórios Brasil e{' '}
        <TextHighlight>comece sua prospecção!</TextHighlight>
      </Text>
    </Container>
  );
}

export default BannerSection;
